<template>
    <div id="chat-menu">
        <div class="conv-head">
            <md-button
                class="new-group"
                @click="addNewChat"
                v-tippy="{
                    followCursor: true,
                    placement: 'bottom-end',
                    theme: isDarkMode ? 'light-border' : 'google',
                }"
                :content="$t('message.addNewGroup')"
            >
                <span class="material-icons">group_add</span>
            </md-button>
        </div>
        <div class="con-type">
            <span class="type" :class="[selected === 'all' && 'selected-type']" @click="selectedThread">{{
                $t("message.all")
            }}</span>
            <span
                class="type"
                :class="[selected === 'departments' && 'selected-type-departments']"
                @click="selectedDepartments"
            >
                {{ $t("message.departments") }}
            </span>
            <span class="type" :class="selected === 'groups' && 'selected-type'" @click="selectedGroups">{{
                $t("message.groups")
            }}</span>
        </div>
        <ChatList :selectedChatType="selected" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { log2 } from "../../../utils/log2";
import ChatList from "./ChatList";

const log = log2("ChatMenu");

export default {
    name: "ChatMenu",
    components: {
        ChatList,
    },
    data() {
        return {
            addGroup: false,
            selected: "all",
        };
    },
    computed: {
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
        }),
    },
    methods: {
        ...mapActions({
            getUsers: "user/getUsers",
            getSubject: "subject/getSubjects",
        }),
        selectedThread() {
            this.selected = "all";
        },

        selectedDepartments() {
            this.selected = "departments";
        },

        selectedGroups() {
            this.selected = "groups";
        },

        addNewChat() {
            this.addGroup = !this.addGroup;
            this.$emit("add-group", this.addGroup);
        },
    },
    async mounted() {},
};
</script>

<style lang="scss">
#chat-menu {
    border: 1px solid #f2f2f2;
    width: 260px;
    max-height: calc(100vh - 45px) !important;
    display: flex;
    flex-direction: column;

    .conv-head {
        display: flex;
        justify-content: center;

        .new-group {
            border-radius: 15px;
            background-color: #ec4a1d;
            color: white;
        }
    }

    .con-type {
        margin: 10px 10px 10px;
        display: flex;
        justify-content: space-between;
        border-radius: 5px;
        background-color: #f2f2f2;
    }

    .type {
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 30%;
        padding: 8px;
        color: black;
        cursor: pointer;
        font-size: 12px !important;
    }

    .selected-type,
    .selected-type-departments {
        border-radius: 5px;
        font-weight: 600;
        background: #ec4a1d;
        color: white;
    }

    .selected-type {
        min-width: 30%;
    }

    .selected-type-departments {
        min-width: 40%;
        margin-right: -5px;
    }

    .coming-chat {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 30px;

        .coming-chat-head {
            font-weight: 700;
            font-size: initial;
        }
    }

    .conversations {
        display: flex;
        border-bottom: 1px solid #f2f2f2;

        &:hover {
            background-color: #fefaf9;
        }

        .conv-active {
            background-color: #ec4a1d;
            width: 4px;
        }

        .conv-info {
            padding: 15px;
            display: flex;
            width: 100%;

            .user-segment-avatar {
                height: 50px;
                width: 50px;
                display: flex;
                align-items: center;
                font-size: 16px;
                background: #6899c1;
                border-radius: 50%;
                margin-right: 15px;
            }

            .user-segment-right {
                width: 80%;
            }

            .conv-info-head {
                justify-content: space-between;
                display: flex;

                .conv-name {
                    font-weight: 600;
                }

                .conv-time {
                    color: #c4c4c4;
                }
            }

            .conv-content {
                color: #c4c4c4;
            }
        }
    }
}
</style>
